// extracted by mini-css-extract-plugin
module.exports = {"Game":"Game_Game__2ZrM-","BoardContainer":"Game_BoardContainer__1ikOD","GameLoader":"Game_GameLoader__WMQCh","LeaderboardContainer":"Game_LeaderboardContainer__3c7Gx"};